import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'


type Options = Required<CreateRouterOptions>

const createModule = (options: Options): RouteConfig[] => {
  (async () => {
    const { registerModule } = await import(
      /* webpackChunkName: "participants.users.store" */
      './store'
    )
    registerModule(options)
  })()

  return []
}

export default createModule
